module.exports = __webpack_public_path__ + "static/other/2c_mail_delivery.4f374ff4.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/2c_mail_delivery.json
// module id = 2493
// module chunks = 0